import { get, post, put, deleted } from '..';
import routes from './routes';

const ReportServices = {
  getCustomerOrders: async (params) => {
    const data = await get(routes.getCustomerOrders, params);
    return data;
  },
  getOrderReportByCustomer: async (id) => {
    const data = await get(routes.getOrderReportByCustomer + id + '/orders');
    return data;
  },
}

export default ReportServices